import "./workout-popup-message.css";
import {useRef} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";

const WorkoutPopupMessage = ({isShown, message, redirectLink}) => {
  console.log(redirectLink);
  const closePopupRef = useRef(null);
  const refLinkToCalendar = useRef(null);
  const navigate = useNavigate();

  // Значення за замовчуванням
  const defaultTitle = "Good job!";
  const defaultSubtitle = "You can check health update";
  const defaultRedirectLink = Routes.workoutPage;

  // Розпаковка масиву message
  const [title = defaultTitle, subtitle = defaultSubtitle] = message || [];

  return (
    <div className="workout-popup-container">
      <div className={`workout-popup-content ${isShown ? "shown-popup" : ""}`}>
        <img
          ref={closePopupRef}
          onClick={() => navigate(redirectLink || defaultRedirectLink)}
          className="workout-popup-close"
          src={require("./workout-popup-message-img/close.svg").default}
          width={32}
          height={32}
          alt="icon close popup"
        />
        <p className="workout-popup-title">{title}</p>
        <p className="workout-popup-subtitle">{subtitle}</p>

        {!message && !redirectLink && (
          <a
            ref={refLinkToCalendar}
            onClick={() => navigate(Routes.calendarPage)}
            className="workout-popup-link"
          >
            here
          </a>
        )}
      </div>
    </div>
  );
};

export default WorkoutPopupMessage;
